"use client";
import { cn as l } from "../../../lib/utils.es.js";
import { buttonVariants as d } from "./Button.variants.es.js";
import { wrapTextNodes as f } from "./utils/wrapTextNodes.es.js";
import { jsx as p } from "react/jsx-runtime";
import { Slot as c } from "@radix-ui/react-slot";
import * as u from "react";
var j = ({ className: a, variant: e, icon: m, asChild: t = !1, isLoading: n = !1, children: s, ...o }) => {
  const i = t ? c : "button", r = u.Children.map(s, f);
  return /* @__PURE__ */ p(i, {
    className: l(d({
      variant: e,
      icon: m,
      className: a
    })),
    "data-slot": "button",
    disabled: o?.disabled || n,
    ...o,
    children: t ? r?.[0] : r
  });
};
export {
  j as default
};
